module.exports = __webpack_public_path__ + "TUSD.svg?cdb7aa9ecbd2df3503ba41093996484c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/TUSD.svg
// module id = 1129
// module chunks = 2